import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { TooltipModule } from 'primeng/tooltip';
import { HrPerOrgUnitPosWithParentPickerComponent } from './hr-per-org-unit-pos-with-parent-picker.component';

@NgModule({
    declarations: [HrPerOrgUnitPosWithParentPickerComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TranslateModule,
        HvlFormItemModule,
        TooltipModule,
    ],
    exports: [HrPerOrgUnitPosWithParentPickerComponent],
})
export class HrPerOrgUnitPosWithParentPickerModule {}
